import { RiLinkedinFill } from "react-icons/ri";
import { AiOutlineGithub } from "react-icons/ai";

const data = [
  {
    link: "https://www.linkedin.com/in/edrisahmaddost/",
    icon: <RiLinkedinFill />,
  },
  {
    link: "https://github.com/edris-hub/homelab-infrastructure",
    icon: <AiOutlineGithub />,
  },
];

export default data;
